import { getCountry, getLocale } from 'i18n/i18nUtils';
import type { TAppSettings } from 'redux-store/settings/settings.store';
import { QUERY_PARAMS } from 'utils/constants';
import { getServiceSettings } from 'utils/getServiceSettings';
import { getDexfSegment, isLocalEnvironment, isProduction } from 'utils/platform';
import useQuery from 'utils/useQuery';

import { CookieConsentDataSourceEnum } from '@inter-ikea-kompis/enums';
import { SettingsService } from '@inter-ikea-kompis/services';

let service: SettingsService;

const getEndpointsOverrides = () => {
  const futureToken = !isProduction() && useQuery(QUERY_PARAMS.FUTURE_TOKEN);
  const testLocale = !isProduction() && useQuery(QUERY_PARAMS.TEST_LOCALE);

  const locale = getLocale();

  const retailUnit = getCountry(locale);

  if (futureToken) {
    return {
      dexfWebplannerService: `https://api.dexf.ikea.com/webplanner/v1/proxy/${futureToken}/items/retailunit/${retailUnit}/locale/${locale}`
    };
  }
  if (testLocale) {
    return {
      dexfWebplannerService: `https://api.dexf.ikea.com/webplanner/v1/query/items/retailunit/${retailUnit}/locale/${locale}`
    };
  }
};

const getService = () => {
  const options = getServiceSettings();

  if (!options.dexfApiKey) {
    throw new Error('No Dexf Api Key available.');
  }

  if (!service) {
    service = new SettingsService(options);
  }

  return service;
};

export const getSettings = async () => {
  const segment = getDexfSegment(); // Filter for which segment you are querying the setting configuration. If not provided it defaults to 'production'.

  let result: TAppSettings | null = null;

  result = await (getService().getApplicationSettings(segment) as Promise<TAppSettings>);

  const cookieConsentOverride = isLocalEnvironment() ? { cookieConsentDataSource: CookieConsentDataSourceEnum.disabled } : {};

  return {
    ...result,
    kompis: {
      ...result.kompis,
      endpoints: {
        ...result.kompis.endpoints,
        ...getEndpointsOverrides()
      },
      serviceSettings: {
        ...result.kompis.serviceSettings,
        ...cookieConsentOverride
      }
    }
  };
};
